// Avatar — renders a One Piece character image when the value is an image
// URL/path, otherwise falls back to the emoji avatar (as a plain span).
// Sized in em so it scales to whatever container/font-size it sits in.

import React from 'react';
import { isImageAvatar, DEFAULT_AVATAR } from '../../config/avatarConfig';
import './Avatar.css';

const MAL_PREFIX = 'https://cdn.myanimelist.net/images/characters/';

// Every character avatar is also saved in public/avatars (see
// backups/avatar-images.json). If MyAnimeList ever drops or blocks an image,
// the player's picture loads from our own copy instead of breaking.
const localCopy = (url) =>
  url.startsWith(MAL_PREFIX) ? `/avatars/${url.slice(MAL_PREFIX.length).replace('/', '-')}` : null;

const handleError = (event) => {
  const img = event.currentTarget;
  const fallback = localCopy(img.dataset.src || '');
  if (fallback && !img.dataset.fellBack) {
    img.dataset.fellBack = '1';
    img.src = fallback;
  }
};

const Avatar = ({ value, className = '', alt = '' }) => {
  if (isImageAvatar(value)) {
    return (
      <img
        src={value}
        data-src={value}
        alt={alt}
        className={`avatar-img ${className}`}
        loading="lazy"
        onError={handleError}
      />
    );
  }
  // A bare word (the server's old 'monkey' default) is not an avatar: show the flag.
  const shown = !value || /^[a-z_-]+$/i.test(value) ? DEFAULT_AVATAR : value;
  return <span className={className}>{shown}</span>;
};

export default Avatar;
